module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.dialogCustomView.title":"Custom View","views.dialogCustomView.tabs.usage":"Usage","views.dialogCustomView.accountType":"{type} Account"}}')
  delete Component.options._Ctor
}
